package com.projectas.app.section

import androidx.compose.runtime.Composable
import com.projectas.app.domain.Feature
import com.projectas.app.util.Constants.LATO_BOLD
import com.projectas.app.util.Constants.LATO_REGULAR
import com.projectas.app.style.LogoStyle
import com.projectas.app.style.TextSelectionStyle
import com.projectas.app.util.Theme
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.shapes.RectF
import com.varabyte.kobweb.silk.theme.shapes.clip
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun FeaturesSection(largeBreakpoint: Boolean) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(
            modifier = Modifier
                .maxWidth(if (largeBreakpoint) 800.px else 350.px),
            horizontalArrangement = Arrangement.Center
        ) {
            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(bottom = 0.px)
                    .color(Theme.Primary.rgb)
                    .fontFamily(LATO_BOLD)
                    .fontSize(if (largeBreakpoint) 2.5.cssRem else 2.cssRem)
                    .lineHeight(value = if (largeBreakpoint) 1.1 else 1.2)
                    .margin(right = if (largeBreakpoint) 12.px else 4.px)
                    .textAlign(TextAlign.Center)
                    .toAttrs()
            ) {
                Text(value = "Why ")

                Span(
                    attrs = Modifier.Companion
                        .color(Theme.Text.rgb)
                        .toAttrs()
                ) {
                    Text("you should use Projectas")
                }
            }
        }

        Surface(
            modifier = Modifier
                .height(size = 50.px)
        ) {}

        SimpleGrid(
            modifier = Modifier.gap(
                rowGap = 60.px,
                columnGap = 24.px
            ),
            numColumns = numColumns(base = 1, lg = 2, xl = 3)
        ) {
            Feature.entries.forEach { feature ->
                FeatureCard(
                    feature = feature,
                    largeBreakpoint = largeBreakpoint
                )
            }
        }
    }
}

@Composable
private fun FeatureCard(
    largeBreakpoint: Boolean,
    feature: Feature,
) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Box(
            modifier = LogoStyle.toModifier()
                .background(Colors.White)
                .size(size = 50.px)
                .margin(right = 24.px)
                .cursor(Cursor.Pointer)
                .padding(all = 12.px)
                .clip(RectF(cornerRadius = 12.px)),
            contentAlignment = Alignment.Center
        ) {
            Image(
                src = feature.icon,
                alt = "Logo Image"
            )
        }
        Column {
            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(topBottom = 0.px)
                    .width(300.px)
                    .color(Theme.Text.rgb)
                    .fontFamily(LATO_REGULAR)
                    .fontSize(if (largeBreakpoint) 1.2.cssRem else 1.1.cssRem)
                    .lineHeight(value = if (largeBreakpoint) 1.6 else 1.4)
                    .toAttrs()
            ) {
                Text(value = feature.title)
            }

            Surface(
                modifier = Modifier
                    .height(size = 6.px)
            ) {}

            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(topBottom = 0.px)
                    .width(300.px)
                    .color(Theme.TextLowVisibility.rgb)
                    .fontFamily(LATO_REGULAR)
                    .fontSize(if (largeBreakpoint) 1.0.cssRem else 0.9.cssRem)
                    .lineHeight(value = if (largeBreakpoint) 1.3 else 1.1)
                    .toAttrs()
            ) {
                Text(value = feature.subtitle)
            }
        }
    }
}